<template>
    <el-dialog 
    v-if="dialogVisible"
     v-dialogDrag
    :visible.sync="dialogVisible" 
    :width="width" 
    :top="top" 
    :fullscreen="dialogFullScreen"
    :append-to-body="appendToBody"
     :modal-append-to-body="modalToBody"
     :close-on-click-modal="false"
    :before-close="close">
        <div slot="title" class="dialogTitle"  v-if="this.$scopedSlots.title">
            <slot name="title"></slot>
        </div>
        <div slot="title" class="dialogTitle" v-else>
            {{title}}
        </div>
        <div v-if="dialogFull" class="avue-crud__dialog__menu" @click="dialogFullScreen? dialogFullScreen=false: dialogFullScreen=true">
            <i class="el-icon-full-screen"></i>
          </div>
        <slot/>
        <span slot="footer" class="dialog-footer" v-if="this.$scopedSlots.footer">
            <slot name="footer"></slot>
        </span>
        <span slot="footer" class="dialog-footer" v-else>
            <el-button  size="small" @click="close">取消</el-button>
            <el-button type="primary" size="small" @click="submitOk">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: '',
    props:{
        dialogFull:{
            type:Boolean,
            default:false
        },
        modalToBody:{
            type:Boolean,
            default:undefined
        },
        appendToBody:{
            type:Boolean,
            default:undefined
        },
        width:{
            type:String,
            default:'600px'
        },
        dialogVisible:{
            type:Boolean,
            default:false
        },
        title:{
            type:String,
            default:"标题"
        },
        top:{
            type:String,
            default:'15vh'
        },
    },
    data() {
        return {
            dialogFullScreen:false,
        }
    },
    components: {},
    computed: {},
    beforeMount() { },
    mounted() { 
        if(this.dialogFull){

        }
    },
    methods: {
        close(){
            this.$emit('close')
            
        },
        submitOk(){
            this.$emit('submit')
        },
    },
}

</script>

<style lang='scss' scoped>
.dialogTitle{
    font-size: 1.8rem;
    font-weight: bold;
}
::v-deep .el-dialog{
    border-radius: 10px;
    overflow: hidden;;
}
::v-deep .el-color-dropdown{
    z-index: 2399;
}
::v-deep .el-dialog__body{
    padding:20px
}
::v-deep .el-dialog__footer{
  padding:15px;
  border-top: 1px solid #dedede;
}
.avue-crud__dialog__menu {
  right: 55px;
  top:22px;
  position: absolute;
}
.avue-crud__dialog__menu i {
  color: #909399;
  font-size: 15px;
}
.el-icon-full-screen{
  cursor: pointer;
  &:hover{
    color:#409EFF;
  }
}
</style>